import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { DialogRef, Modal, overlayConfigFactory } from 'ngx-modialog';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../utils/services/api.service';
import { ParameterService } from '../../../../utils/services/parameter.service';
import { modalConfig } from '../../../../app.module';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  public formGroup: FormGroup;
  decline = false;
  approve = false;




  constructor(private apiService: ApiService, private httpService: ParameterService, private notifications: NotificationsService, public modal: Modal, public dialog: DialogRef<any>) {
    this.registerId = this.dialog.context.registerId
    this.register = this.dialog.context.register
    this.value = this.dialog.context.value
  }

  ngOnInit() {
    this.formGroup = new FormGroup({
      'username': new FormControl(null,[Validators.email,Validators.required]),
      'password': new FormControl(null,Validators.required),
      'commission': new FormControl(null)
    });
    this.fetchHotels();
  }


  @ViewChild('hotelListTemplate') hotelSearchModal;
  @ViewChild('bodyElement') bodyElement: ElementRef;

  modalOpen;
  public registerId;
  public value;
  public register;
  summary=false;
  hotel;


showSummary(){
  this.summary=true
  console.log(this.register)
}
  updateRegistration(formGroup) {
    let data = {
      username: formGroup.username,
      password: formGroup.password,
      commission: formGroup.commission ? (+formGroup.commission) : 0,
      hotelId: this.hotelId
    }
    if(this.formGroup.valid){
      this.apiService.confirmHotelRegistration(this.registerId, data).subscribe(res => {
        if (res.data) {
          this.notifications.success('Success', 'Registration confirmed!');
          this.dialog.close({ type: 'CONFIRM', result: true });
        }
      }, err => {
        this.notifications.error('Error', 'Operation failed!');
      })
    }else{
      if(this.formGroup.controls.username.errors){
        this.notifications.warn('Warning','Invalid Email')
      }
      if(this.formGroup.controls.password.errors){
        this.notifications.warn('Warning','Password is required')
      }
    }
    
   
  }

  declineRegistration() {
    this.apiService.rejectHotelRegistration(this.registerId, this.hotelId).subscribe(res => {
      if (res.data) {
        this.notifications.success('Success', 'Registration declined!');
        this.dialog.close({ type: 'DECLINE', result: true });
      }
    }, err => {
      this.notifications.error('Error', 'Operation failed!');
    })
  }
  findHotel() {
    this.modalOpen = this.modal.open(this.hotelSearchModal, modalConfig);
    this.fetchHotels();
  }
  count1 = 0;
  hotelList = null;
  hotelId;
  hotelName;
  searchParam1;
  hotelsLoading = false;
  hotelSearchParam = {
    'limit': 5,
    'offset': 0,
    'sortBy': 'id',
    'sortType': 'desc',
    'status_Eq': 'Active',
    'name_Sw': '',
    'cityId_In': []
  }
  fetchHotels(isLoadMore = false) {
    this.hotelsLoading = true;
    if (!isLoadMore) {
      this.hotelSearchParam.offset = 0;
    }
    this.searchParam1 = new URLSearchParams();
    Object.keys(this.hotelSearchParam).forEach(key => {
      if (key === 'name_Sw' && this.hotelSearchParam[key].length > 0) {
        this.searchParam1.set(key, this.hotelSearchParam[key])
      }
      if (key === 'cityId_In' && this.hotelSearchParam[key].length > 0) {
        this.searchParam1.set(key, this.hotelSearchParam[key].map(p => p.bizihotelCityId).toString());
      }
      if (key != 'name_Sw' && key != 'cityId_In') {
        this.searchParam1.set(key, this.hotelSearchParam[key]);
      }
    })
    this.httpService.getHotels(this.searchParam1.toString()).subscribe(res => {
      this.count1 = res.data.count;
      if (res.data.rows.length > 0) {
        if (isLoadMore) {
          res.data.rows.map(p => {
            let len = p.stars;
            p.stars = [];
            p.stars.length = len;
            this.hotelList.push(p);
          });
        } else {
          this.hotelList = res.data.rows.map(p => {
            let len = p.stars;
            p.stars = [];
            p.stars.length = len;
            return p;
          });
        }
      } else {
        this.hotelList = [];
      }
      this.hotelsLoading = false;

    }, err => {
      this.hotelList = []
      this.hotelsLoading = false;

    })
  }
  closeModal() {
    this.dialog.close();
  }
  selectedHotelIndex = -1;
  showValidatorsOrgHotel = false;
  selectHotel(hotel, index) {
    this.selectedHotelIndex = index;
    console.log(hotel)
    this.hotelId = hotel.hotelId
    this.hotelName = hotel.name
    this.hotel=hotel
    this.bodyElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  changeHotel() {
    this.hotelId = null
    this.summary=false
  }

  infiniteScrollEnd = true;
  @HostListener("scroll", ['$event'])
  scrollMe(event) {
    let tracker = event.target;
    let limit = tracker.scrollHeight - tracker.clientHeight;
    console.log("scrollme", this.hotelList, this.count1)
    if ((tracker.scrollTop) >= limit - 1 && this.hotelList && this.hotelList.length < this.count1) {
      this.hotelSearchParam.offset += 5;
      this.fetchHotels(true);
    }

  }


}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/hotel-register-requests/modal/modal.component.ts